<template>
  <div class="record-item">
    <header class="record-item__header">
      <h3 class="record-item__title">{{ uploadTitle }}</h3>
    </header>
    <footer class="record-item__footer">
      <div v-if="!audioUrlBlob" style="padding-top: 10px">
        <UploadProgress :progress="progress" />
      </div>
      <AudioPlayer v-else ref="isAideo" :audio-url="audioUrlBlob" :is-quick="false" />
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import AudioPlayer from '@/components/audio-player.vue'
import UploadProgress from '@/components/progress.vue'

defineOptions({
  name: 'RecordCard'
})

const props = defineProps({
  audioUrl: {
    type: String,
    default: ''
  },
  audioUrlBlob: {
    type: String,
    default: ''
  },
  progress: {
    type: Number,
    default: 0
  },
  uploadTime: {
    type: String,
    default: ''
  }
})
const uploadTitle = computed(() => {
  return props.uploadTime ? `${props.uploadTime} 录音` : '本地录音'
})
</script>

<style lang="scss" scoped>
.record-item {
  border: 1px solid #e5e6eb;
  border-radius: 20px;
  padding: 12px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
  }

  &__duration {
    font-size: 12px;
    color: #969799;
  }

  &__actions {
    display: flex;

    > * {
      margin-right: 12px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__footer {
    height: 34px;
  }

  // 医疗行业特殊样式
  &--medical {
    border: 1px solid #e5e6eb;
    padding: 12px;
    background: #fff;
    position: relative;
  }

  &__medical-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__medical-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  &__medical-time {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 600 !important;
    font-weight: normal;
    line-height: 20px;
    color: #323233;
  }

  &__medical-duration {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: #969799;
  }

  &__medical-submit {
    margin-left: 12px;
    flex-shrink: 0;
    padding: 8px 16px;
    font-size: 14px;
    color: #7a52f4;
    cursor: pointer;
  }
}
</style>
